var exports = {
  "Wl": "EmbedImage.module__imagePreviewHandler___bzlocG",
  "kL": "EmbedImage.module__container___bzlocG",
  "qd": "EmbedImage.module__rowContainer___bzlocG",
  "Ub": "EmbedImage.module__justifyEnd___bzlocG",
  "WH": "EmbedImage.module__innerContainer___bzlocG",
  "h4": "EmbedImage.module__imageWrapper___bzlocG",
  "ZS": "EmbedImage.module__imageContainer___bzlocG",
  "dm": "EmbedImage.module__imageInnerContainer___bzlocG",
  "tN": "EmbedImage.module__blurContainer___bzlocG",
  "Iu": "EmbedImage.module__thumbHashContainer___bzlocG",
  "kv": "EmbedImage.module__thumbHashImage___bzlocG",
  "il": "EmbedImage.module__mediaContainer___bzlocG",
  "or": "EmbedImage.module__cursorPointer___bzlocG",
  "qH": "EmbedImage.module__imageElement___bzlocG",
  "bO": "EmbedImage.module__animatedImageElement___bzlocG",
};

module.exports = exports;
